import HNSColors from "../../../../../../../ui library/HNSColors";

export const staticSelectStyles = {
  "& .MuiInputBase-input": {
    padding: "8px !important",
  },
  "& .MuiInputBase-input textarea": {
    padding: "8px !important",
  },
};

export const addButtonStyles = (hasDisposition) => ({
  color: HNSColors.secondary[500],
  border: `1px solid ${HNSColors.secondary[500]}`,
  marginBottom: hasDisposition ? "1rem" : 0,
  "&:hover": {
    background: HNSColors.secondary[900],
    border: `1px solid ${HNSColors.secondary[500]}`,
  },
});
